import { useEffect, useState } from "react";

import { deviceStorage, readSkin, SKIN_EVENT, type Skin } from "./skin";

/** The current skin, following saves on this window and on other windows. */
export function useSkin(): Skin {
  const [skin, setSkin] = useState<Skin>(() => readSkin(deviceStorage()));
  useEffect(() => {
    const onSave = (event: Event) => {
      const detail = (event as CustomEvent<Skin>).detail;
      setSkin(detail ?? readSkin(deviceStorage()));
    };
    const onStorage = () => setSkin(readSkin(deviceStorage()));
    window.addEventListener(SKIN_EVENT, onSave);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(SKIN_EVENT, onSave);
      window.removeEventListener("storage", onStorage);
    };
  }, []);
  return skin;
}
